/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Method_Bank_TransferInputs */

const vi_tea_purchase_payment_method_bank_transfer = /** @type {(inputs: Tea_Purchase_Payment_Method_Bank_TransferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển khoản`)
};

/**

* @param {Tea_Purchase_Payment_Method_Bank_TransferInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_method_bank_transfer = /** @type {((inputs?: Tea_Purchase_Payment_Method_Bank_TransferInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Method_Bank_TransferInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_method_bank_transfer(inputs)
});